import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from 'pinia';
import store from "./store";
import i18n from './locales';
const app = createApp(App);
import {
  Search,
  Icon,
  Toast,
  Button,
  Cell,
  CellGroup,
  Tab,
  Tabs,
  Form,
  Field,
  Loading,
} from "vant";
app
  .use(router)
  .use(Search)
  .use(Icon)
  .use(Toast)
  .use(Button)
  .use(CellGroup)
  .use(Cell)
  .use(Tab)
  .use(Tabs)
  .use(Form)
  .use(Field)
  .use(Loading)
  .use(store)
  .use(createPinia())
  .use(i18n)
  .mount("#app");
